<template>
  <BlBackdrop
    title="Jump to a specific date"
    label="Confirm"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSubmit"
  >
    <div class="pl-3.5 pr-8 flex justify-center relative w-160">
      <div
        class="absolute z-10 flex items-center gap-4 px-12 bg-pure-white"
        :style="{ right: '10px', top: '8px', height: '32px' }"
      >
        <BlInputButton
          type="outlined"
          dense
          label="Today"
          @clicked="onDayClick({ date: new Date() })"
        />
        <BlInputButton
          type="outlined"
          dense
          icon="chevron-left"
          class="border-none"
          @clicked="onMoveCalendar(-1)"
        />
        <BlInputButton
          type="outlined"
          dense
          icon="chevron-right"
          class="border-none"
          @clicked="onMoveCalendar(1)"
        />
      </div>
      <v-calendar
        ref="calendar"
        is-expanded
        hide-header
        title-position="left"
        :attributes="attrs"
        class="border-none"
        @dayclick="onDayClick"
      />
    </div>
  </BlBackdrop>
</template>

<script>
import moment from "moment";

import BlBackdrop from "../../BlBackdrop.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "JumpToDateModal",
  components: {
    BlBackdrop,
    BlInputButton
  },
  props: ["currentDate", "dimension"],
  data() {
    return {
      date: new Date()
    };
  },
  computed: {
    attrs() {
      const solid = "bg-light-purple border-2 border-light-purple";
      const solidRange = "bg-light-purple-100 border-2 border-light-purple";
      const light = "bg-light-purple-200 border-2 border-light-purple-200";
      const lightRange = "bg-light-purple-100 border-2 border-light-purple-200";
      const weeklyToday = {
        start: { fillMode: "solid", class: solid },
        base: { fillMode: "light", class: solidRange },
        end: { fillMode: "solid", class: solid }
      };
      const weeklySelected = {
        start: { fillMode: "light", class: light },
        base: { fillMode: "light", class: lightRange },
        end: { fillMode: "light", class: light }
      };

      const todayDates = this.generateDates(new Date());
      const today = {
        key: "today",
        highlight:
          this.dimension === "weekly"
            ? weeklyToday
            : { class: solid, fillMode: "solid" },
        dates: todayDates
      };
      const selected = {
        key: "selected",
        highlight:
          this.dimension === "weekly"
            ? weeklySelected
            : { class: light, fillMode: "light" },
        dates: this.generateDates(this.date)
      };

      if (this.dimension === "weekly") {
        const isSameWeek = moment(this.date).isBetween(
          moment(todayDates.start, "YYYY-MM-DD"),
          moment(todayDates.end, "YYYY-MM-DD")
        );
        if (isSameWeek) return [today];
      } else {
        const isSameDay =
          moment().format("YYYY-MM-DD") ===
          moment(this.date).format("YYYY-MM-DD");
        if (isSameDay) return [today];
      }
      return [today, selected];
    }
  },
  mounted() {
    this.onDayClick({ date: this.currentDate });
  },
  methods: {
    generateDates(date) {
      if (this.dimension === "weekly") {
        const startDate = moment(date)
          .startOf("isoWeek")
          .format("YYYY-MM-DD");
        const endDate = moment(date)
          .endOf("isoWeek")
          .format("YYYY-MM-DD");
        return { start: startDate, end: endDate };
      } else {
        return date;
      }
    },
    async onSyncCalendar(d) {
      const month = moment(d).format("M");
      const year = moment(d).format("YYYY");
      const calendar = this.$refs.calendar;
      if (calendar) await calendar.move({ month, year });
    },
    async onMoveCalendar(month) {
      const calendar = this.$refs.calendar;
      if (calendar) await calendar.move(month);
    },
    onDayClick(day) {
      const d = day.date;
      this.date = d;
      this.onSyncCalendar(d);
    },
    onSubmit() {
      const d = this.date;
      this.$emit("submit", d);
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/availabilities/timeslot/JumpToDateModal.vue